export const root:string = "http://knucklessux.com/InfoTokenReader/Bullshit/";
export const folder_index:string = root + "list.php";
export const word_thoughts:string = "WordThoughts";
export const audio_thoughts:string = "AudioThoughts";
export const picture_thoughts:string = "PictureThoughts";